<div class="row">
    <div class="col-12">
        <data-table>
            <data-row>
                <custom-select [label]="'keep-existing-product-plan-on-discontinuation.source-tag' | translate" [selectList]="selectListTags" [(value)]="setting.sourceTag" (valueChange)="valueChange()" [required]="true" />
            </data-row>
            <data-row>
                <custom-select [label]="'keep-existing-product-plan-on-discontinuation.destination-tag' | translate" [selectList]="selectListTags" [(value)]="setting.destinationTag" (valueChange)="valueChange()" [required]="true" />
            </data-row>
        </data-table>
    </div>
</div>
